export default {"src":"/_next/static/media/one-designer-call.d7f616a0.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};